exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#app[data-v-4fbc735b] {\n  display: grid;\n  grid-template-columns: 1fr  auto  1fr;\n  grid-template-rows: 1fr  auto  1fr;\n  height: 90%;\n}\n.rack[data-v-4fbc735b] {\n  display: grid;\n  grid-template-columns: repeat(6, auto);\n  grid-column: 2;\n  grid-row: 2;\n}\n", ""]);

// exports
